import { Box } from '@mui/joy';
import { useState, useRef, useEffect } from 'react';
import JSONPretty from 'react-json-pretty';
import { useFormatter, useString } from 'src/mtska-frontend-app-component/utils';
import { useTranslation } from 'react-i18next';

const RevenueDealNode = (props) => {
    const ref = useRef(null);
    const { formatDate } = useFormatter();
    const { t } = useTranslation();
    const [rulesets, setRulesets] = useState();

    useEffect(() => {
        if (!props.item) return;
        if (props.item.revenueRulesets ) {
            setRulesets(props.item.revenueRulesets);
        }
        if (props.item.commissionRulesets ) {
            setRulesets(props.item.commissionRulesets);
        }
    }, [props.item])

    const { toColor } = useString();

    return (
        <Box ref={ref} className="flow-node flow-node-deal">
            {/* <JSONPretty data={rulesets} className='json-wrapper' /> */}
            <Box className="partner" style={{ backgroundColor: toColor(props.item.partner.name + props.item.partner.name) }}>{props.item.partner.name} {props.item.partner.logo}</Box>
            <Box className="title">{props.item.name}</Box>
            <Box className="dates">
                <Box className="start_at">{formatDate(props.item.start_at)}</Box>
                <Box className="end_at">{formatDate(props.item.end_at)}</Box>
            </Box>
            <Box className="priority">{props.item.siblingPriority}</Box>
            <Box className="rulesets">
                {
                    (rulesets ?? []).map((ruleset) => {
                        return <Box className="ruleset">
                            <Box className="production">{ruleset.production}</Box>
                            <Box className="rules">
                                {(ruleset.revenueRules ?? ruleset.commissionRules ?? []).map((rule) => {
                                    return <Box className="rule">
                                        <Box className="field">{t((rule.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                                        <Box className="operator">{t(rule.operator)}</Box>
                                        <Box className="value">{rule.value}</Box>
                                    </Box>
                                })}
                                {(ruleset.revenueRules ?? ruleset.commissionRules ?? []).length == 0 && <em>No rules</em>}
                            </Box>
                        </Box>
                    })
                }
            </Box>
        </Box>
    );
};

export default RevenueDealNode